import dayjs from "dayjs";

const DateTime = ({ utcValue, defaultValue = "-" }) => {
  return (
    <>
      {!!utcValue
        ? dayjs(utcValue).utc(false).local().format("YYYY-MM-DD hh:mm A")
        : defaultValue}
    </>
  );
};

export default DateTime;
